import React from 'react';

export interface UndoState {
    undoPush: (value: any) => void;
    canRedo: () => boolean;
    canUndo: () => boolean;
    undo: () => any;
    redo: () => any;
}

export function createUndoState(initialValue?: any) {

    const items: any[] = [];
    var index = -1;

    if (initialValue !== undefined) {
        items.push(initialValue);
        index = 0;
    }

    function undoPush(value: any) {

        // just check in case the value matches exactly most recent history item
        if (index >= 0) {
            if (items[index] === value) {
                // exact same so ignore
                return;
            }
        }

        // if we had undone back a few steps and then made a new change then flush the items after in the array
        if (index >= 0 && index < (items.length - 1)) {
            items.splice(index+1);
        }

        items.push(value);

        index = items.length-1;
    }

    function canUndo() {
        return (index > 0);
    }
    function canRedo() {
        return (index < (items.length - 1));
    }

    function undo() {
        if (!canUndo()) return undefined;

        // NOTE: canRedo ensures this is possible, so no extra validation of index required
        index--;
        
        return items[index];
    }

    function redo() {
        if (!canRedo()) return undefined;

        // NOTE: canRedo ensures this is possible, so no extra validation of index required
        index++;

        return items[index];
    }

    return {
        undoPush,
        canUndo,
        canRedo,
        undo,
        redo,
    };

}

// const {  } hooks.useUndo();
export function useUndo() {

    const [ undo ] = React.useState(createUndoState);

    return undo;

}
